// extracted by mini-css-extract-plugin
export var separator = "vertical-spacing-module--separator--jwyAD";